import { ActivityFilterType } from "@coworker/apprestructured/src/activity/types/filterOptionsTypes";

export const getAppliedFiltersCount = (filters: ActivityFilterType) => {
  if (!filters || typeof filters !== "object") return 0;
  return Object.entries(filters).reduce((acc, [key, value]) => {
    // Skip 'sortedBy' key
    if (key === "sortedBy") {
      return acc;
    }

    // Count array values by length
    if (Array.isArray(value)) {
      return acc + value.filter(Boolean).length; // Filter out falsy values in arrays
    }

    // Count non-empty values
    if (value && value !== "") {
      return acc + 1;
    }

    return acc;
  }, 0);
};
